import getDefaultCycle, { getCycleTypeId } from "lib/utils/cycles";
import _ from "lodash";

const computeScenarioTotalsForCard = (scenario, referenceScenario) => {
  return {
    ...scenario,
    units: {
      absolute: scenario.units,
      percentage:
        scenario.units - referenceScenario.units !== 0
          ? (100 * (scenario.units - referenceScenario.units)) /
            referenceScenario.units
          : 0,
    },
    units_in: {
      absolute: scenario.units_in,
      percentage:
        scenario.units - referenceScenario.units_in !== 0
          ? (100 * (scenario.units_in - referenceScenario.units_in)) /
            referenceScenario.units_in
          : 0,
    },
    margin: {
      absolute: scenario.margin,
      percentage:
        scenario.margin - referenceScenario.margin !== 0
          ? (100 * (scenario.margin - referenceScenario.margin)) /
            referenceScenario.margin
          : 0,
    },
    sales: {
      absolute: scenario.sales,
      percentage:
        scenario.sales - referenceScenario.sales !== 0
          ? (100 * (scenario.sales - referenceScenario.sales)) /
            referenceScenario.sales
          : 0,
    },
    sales_in: {
      absolute: scenario.sales_in,
      percentage:
        scenario.sales_in - referenceScenario.sales_in !== 0
          ? (100 * (scenario.sales_in - referenceScenario.sales_in)) /
            referenceScenario.sales_in
          : 0,
    },
    investment_in: {
      absolute: scenario.investment_in - referenceScenario.investment_in,
      percentage: 0,
    },
    investment: {
      absolute: scenario.investment - referenceScenario.investment,
      percentage: 0,
    },
    roi: {
      // eslint-disable-next-line no-restricted-globals
      absolute: isFinite(scenario.roi) ? _.round(scenario.roi, 1) : "N/A",
      percentage: 0,
    },
    price: {
      absolute: scenario.weighted_avg_price_units,
      percentage:
        scenario.weighted_avg_price_units -
          referenceScenario.weighted_avg_price_units !==
        0
          ? (100 *
              (scenario.weighted_avg_price_units -
                referenceScenario.weighted_avg_price_units)) /
            referenceScenario.weighted_avg_price_units
          : 0,
    },
  };
};

export function handlePathName(location) {
  const pathName = location.substring(location.lastIndexOf("/") + 1);
  switch (pathName) {
    case "pricing":
      return "Pricing";
    default:
      return "Trade Promotions";
  }
}

export function handleScenarioType(typeId) {
  switch (typeId) {
    case 1:
      return "Pricing";
    case 2:
      return "Trade Promotions";
    case 3:
      return "Pricing 2.0";
    case 4:
      return "Daily Trade Promotions";
    default:
      return "Trade Promotions";
  }
}

export const handleCycleType = (id, cycleSlice) => {
  const cycleTypeList = _.filter(cycleSlice.list, (cycle) => {
    return cycle.cycle_type_id === id;
  });
  return cycleTypeList;
};

export const handleCycleTypeList = (cycleTypeList) => {
  let currentCycle;
  if (cycleTypeList?.length > 0) {
    currentCycle = getDefaultCycle(cycleTypeList);
  }
  return currentCycle;
};

export const handleInitialSelectedScenarioTotals = (
  currentCycle,
  totalsByScenarioId
) => {
  return _.find(
    totalsByScenarioId,
    (scenarioTotal) =>
      scenarioTotal.scenario.scenario_type_id === 1 &&
      scenarioTotal.scenario.cycle_id === currentCycle
  );
};
const renameKeys = (keysMap, obj) =>
  Object.keys(obj).reduce(
    (acc, key) => ({
      ...acc,
      ...{ [keysMap[key] || key]: obj[key] },
    }),
    {}
  );

export const scenarioEstimationAggregatedTranslate = (
  keyMaps,
  scenarioEstimations
) => {
  return _.map(scenarioEstimations, (estimation) => {
    return renameKeys(keyMaps, estimation);
  });
};

export const currentDefaultScenario = (
  cycleLabelType,
  totalsByScenarioId,
  cycleSlice
) => {
  // So we need to detect what kind of cycle is and set the default scenario.
  const cycleTypeList = handleCycleType(
    getCycleTypeId(cycleLabelType, cycleSlice)[0].id,
    cycleSlice
  );
  // We need to take a default cycle for the cycleType specified
  const currentCycle = handleCycleTypeList(cycleTypeList);
  const selectedScenarioTotal = handleInitialSelectedScenarioTotals(
    currentCycle,
    totalsByScenarioId
  );
  return selectedScenarioTotal;
};

export default computeScenarioTotalsForCard;
